import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import {
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  EditOutlined,
  DeleteOutline,
  PersonAddAltOutlined,
  SearchOutlined,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useSelector, useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import _ from "lodash";

//Services
import DispatcherApi from "Services/Dispatcher";

//Modals
import DispatcherAddModal from "Pages/Modals/Dispatcher/Create";
import DispatcherUpdateModal from "Pages/Modals/Dispatcher/Update";
import DispatcherDeleteDialog from "Pages/Modals/Dispatcher/Delete";

const Dispatcher = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const demoaccount_id = useSelector((state) => state?.AuthReducer?.demoaccount_id || "");

  const [searchText, setSearchText] = useState("");
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [customerId, setCustomerId] = useState("");

  // Pagination
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // Modals
  const [addDispatcherModal, setAddDispatcherModal] = useState(false);
  const [updateDispatcherModal, setUpdateDispatcherModal] = useState(false);
  const [deleteDispatcherModal, setdeleteDispatcherModal] = useState(false);

  const handleOpenAddDispatcherModal = () => setAddDispatcherModal(true);
  const handleCloseAddDispatcherModal = () => {
    setAddDispatcherModal(false);
    getDispatchers();
  };

  const handleOpenUpdateDispatcherModal = (rowItem) => {
    setCustomerId(rowItem?._id);
    setUpdateDispatcherModal(true);
  };
  const handleCloseUpdateDispatcherModal = () => {
    setUpdateDispatcherModal(false);
    getDispatchers();
  };

  const handleOpenDeleteDispatcherModal = (rowItem) => {
    setCustomerId(rowItem?._id);
    setdeleteDispatcherModal(true);
  };
  const handleCloseDeleteServiceModal = () => {
    setdeleteDispatcherModal(false);
    getDispatchers();
  };

  // Get Dispatchers list
  const getDispatchers = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
    };
    const params = { page, limit: pageSize, search: "" };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    DispatcherApi.getDispatchersList(params).then(onSuccess, onFailure);
  }, [page, pageSize, demoaccount_id, dispatch]);

  const getalldispatchers = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = () => {};
    const params = { page: 1, limit: "unlimited", search: "" };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    DispatcherApi.getDispatchersList(params).then(onSuccess, onFailure);
  }, [demoaccount_id]);

  useEffect(() => {
    getDispatchers();
    getalldispatchers();
  }, [getDispatchers, getalldispatchers]);

  const calculateSno = (pageIndex, pSize, index) => {
    return (pageIndex - 1) * pSize + index + 1;
  };

  const filteredRow = (row || []).filter((data) => {
    if (!searchText) return true;
    const searchLower = searchText.toLowerCase();
    const fullName = `${data?.firstName || ""} ${data?.lastName || ""}`.toLowerCase();
    const mobile = `${data?.countryCode || ""} ${data?.mobileNumber || ""}`.toLowerCase();
    return (
      fullName.includes(searchLower) ||
      data?.email?.toLowerCase().includes(searchLower) ||
      mobile.includes(searchLower)
    );
  });

  const dataRows = _.map(filteredRow || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    firstName: data?.firstName + " " + data?.lastName,
    email: data?.email,
    mobile: (data?.countryCode || "") + " " + (data?.mobileNumber || ""),
    row: data,
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ["createdAt"], ["asc"]),
    (data, index) => ({
      sno: index + 1,
      firstName: data?.firstName + " " + data?.lastName,
      email: data?.email,
      mobile: (data?.countryCode || "") + " " + (data?.mobileNumber || ""),
    })
  );

  const formatteddatas = dataRows.map((r) => ({
    "S.NO": r.sno,
    "Full Name": r.firstName,
    Email: r.email,
    Mobile: r.mobile,
  }));

  const bulkformatteddatas = bulkdataRows.map((r) => ({
    "S.NO": r.sno,
    "Full Name": r.firstName,
    Email: r.email,
    Mobile: r.mobile,
  }));

  // Export handlers
  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All DispatcherList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopy = () => {
    const header = ["S.NO", "Full Name", "Email", "Mobile"].join("\t");
    const rows = dataRows.map((r) => [r.sno, r.firstName, r.email, r.mobile].join("\t")).join("\n");
    navigator.clipboard.writeText([header, rows].join("\n")).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dispatchers");
    XLSX.writeFile(workbook, "DispatcherList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "DispatcherList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((r) => [r.sno, r.firstName, r.email, r.mobile]);
    doc.autoTable({
      head: [["S.NO", "Full Name", "Email", "Mobile"]],
      body: tableData,
    });
    doc.save("DispatcherList.pdf");
  };

  // Pagination
  const totalPagesCount = Math.ceil(totalPages / pageSize) || 1;

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1;
    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) pages.push(i);
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [0, "...", totalPagesCount - 3, totalPagesCount - 2, totalPagesCount - 1];
      } else {
        pages = [0, "...", internalPage - 1, internalPage, internalPage + 1, "...", totalPagesCount - 1];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }
      return (
        <Button
          key={item}
          className={internalPage === item ? classes.pageButtonActive : classes.pageButton}
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  return (
    <Box className={classes.root}>
      {/* Header */}
      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>Dispatchers</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Dispatchers</span>
        </Typography>
      </Box>

      {/* Action Row */}
      <Box className={classes.actionRow}>
        <Box className={classes.searchWrapper}>
          <SearchOutlined className={classes.searchIcon} />
          <input
            type="text"
            placeholder="Search dispatchers..."
            className={classes.searchInput}
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
        </Box>

        <Box className={classes.rightActions}>
          <Box className={classes.exportGroup}>
            <Button className={classes.exportButton} onClick={handleCopy}>Copy</Button>
            <Button className={classes.exportButton} onClick={handleDownloadExcel}>Excel</Button>
            <Button className={classes.exportButton} onClick={handleDownloadCSV}>CSV</Button>
            <Button className={classes.exportButton} onClick={handleDownloadPDF}>PDF</Button>
            <Button className={classes.exportButton} onClick={handleDownloadAll}>All</Button>
          </Box>

          <Button
            variant="contained"
            className={classes.addButton}
            onClick={handleOpenAddDispatcherModal}
            startIcon={<PersonAddAltOutlined />}
          >
            Add Dispatcher
          </Button>
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell}>S.No</TableCell>
              <TableCell className={classes.tableHeaderCell}>Full Name</TableCell>
              <TableCell className={classes.tableHeaderCell}>Email</TableCell>
              <TableCell className={classes.tableHeaderCell}>Mobile</TableCell>
              <TableCell className={classes.tableHeaderCell} align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{rowItem.sno}</TableCell>
                <TableCell className={`${classes.tableCell} ${classes.boldText}`}>
                  {rowItem.firstName}
                </TableCell>
                <TableCell className={classes.tableCell}>{rowItem.email}</TableCell>
                <TableCell className={classes.tableCell}>{rowItem.mobile}</TableCell>
                <TableCell className={classes.tableCell} align="right">
                  <Box
                    component="span"
                    className={classes.actionButton}
                    onClick={() => handleOpenUpdateDispatcherModal(rowItem.row)}
                  >
                    <EditOutlined fontSize="small" />
                    Edit
                  </Box>
                  <Box
                    component="span"
                    className={classes.actionDeleteButton}
                    onClick={() => handleOpenDeleteDispatcherModal(rowItem.row)}
                  >
                    <DeleteOutline fontSize="small" />
                    Delete
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} style={{ textAlign: "center", padding: "40px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No dispatchers found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        {/* Pagination */}
        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + (dataRows.length > 0 ? 1 : 0)} to{" "}
            {Math.min(page * pageSize, totalPages)} of {totalPages} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />
            {renderPagination()}
            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>

      <DispatcherAddModal
        openDialog={addDispatcherModal}
        handleClose={handleCloseAddDispatcherModal}
      />
      <DispatcherUpdateModal
        openDialog={updateDispatcherModal}
        id={customerId}
        handleClose={handleCloseUpdateDispatcherModal}
      />
      <DispatcherDeleteDialog
        openDialog={deleteDispatcherModal}
        id={customerId}
        handleClose={handleCloseDeleteServiceModal}
      />
    </Box>
  );
};

export default Dispatcher;
